import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, Sofa, Layers, BedDouble, Lightbulb, Snowflake } from 'lucide-react';

const ServicesSection = () => {
  const services = [
    {
      icon: Sofa,
      title: 'Living Room Decoration',
      description:
        'Transform your main gathering space with curated furniture arrangements, color schemes, and accent pieces that create warmth and sophistication.',
      image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?auto=format&fit=crop&w=800&q=80',
    },
    {
      icon: Layers,
      title: 'Accent Wall & Wallpaper Styling',
      description:
        'Make a bold statement with thoughtfully designed feature walls using premium wallpapers, textured finishes, or artistic paint techniques.',
      image: 'https://images.unsplash.com/photo-1615529328331-f8917597711f?auto=format&fit=crop&w=800&q=80',
    },
    {
      icon: BedDouble,
      title: 'Bedroom Enhancements',
      description:
        'Create your personal sanctuary with carefully selected linens, lighting, and decor that promote relaxation and restful sleep.',
      image: 'https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=800&q=80',
    },
    {
      icon: Lightbulb,
      title: 'Lighting & Decor Consultation',
      description:
        'Optimize your spaces with strategic lighting plans and decorative elements that enhance ambiance and functionality.',
      image: 'https://images.unsplash.com/photo-1507089947368-19c1da9775ae?auto=format&fit=crop&w=800&q=80',
    },
    {
      icon: Snowflake,
      title: 'Seasonal Decoration Updates',
      description:
        'Keep your home fresh and inviting with seasonal styling updates that reflect the changing moods throughout the year.',
      image: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=800&q=80',
    },
  ];

  return (
    <section
      data-testid="services-section"
      className="section-padding bg-[#FAF9F6]"
    >
      <div className="container-main">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-xs uppercase tracking-[0.3em] text-[#C5A065] mb-4 block">
            What We Offer
          </span>
          <h2
            data-testid="services-title"
            className="font-heading text-3xl md:text-4xl text-[#2D2D2D] mb-6"
          >
            Our Decoration Services
          </h2>
          <p className="text-[#6E6E6E] leading-relaxed">
            From subtle enhancements to complete room transformations, we offer
            comprehensive decoration services tailored to your needs.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              data-testid={`service-card-${index}`}
              className="service-card card-editorial group"
            >
              <div className="image-hover-zoom mb-6 aspect-[4/3]">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-[#FAF9F6] flex items-center justify-center group-hover:bg-[#C5A065] transition-colors">
                  <service.icon className="w-5 h-5 text-[#C5A065] group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-heading text-xl text-[#2D2D2D]">
                  {service.title}
                </h3>
              </div>
              <p className="text-[#6E6E6E] text-sm leading-relaxed mb-4">
                {service.description}
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center text-[#C5A065] text-sm font-medium hover:gap-3 transition-all gap-2"
              >
                Learn More <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          ))}
        </div>

        {/* Pricing Note */}
        <div className="mt-12 text-center">
          <p className="text-sm text-[#6E6E6E] italic">
            Project scope and pricing vary based on room size, materials, and
            customization requirements.
          </p>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <Link to="/services">
            <Button
              data-testid="services-view-all-btn"
              className="btn-secondary"
            >
              View All Services
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
